import { render, staticRenderFns } from "./AssetImageLinkUpdateScreen.vue?vue&type=template&id=3a506a56&"
import script from "./AssetImageLinkUpdateScreen.vue?vue&type=script&lang=js&"
export * from "./AssetImageLinkUpdateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports